import React from "react"
import MediaBox from "./MediaBox"
import styled from "styled-components"
import { Button, RawHTML } from "buoy-core"
import { injectIntl } from "react-intl"

const Option = styled(Button)`
  min-width: unset;
  margin: 6px 0;
  text-align: right;
`

const OptionButton = ({ option, onClick, hidden, scroll, selected, intl }) => {
  let { formatMessage } = intl
  // This next line is important for supporting different languages. If the option.text
  // has an id, then it is translatable
  const text =
    option.text && option.text.id ? formatMessage(option.text) : option.text

  return (
    <Option
      buttonStyle="chat"
      className="answer-option"
      selected={selected}
      key={option.token}
      onClick={e => {
        onClick(option)
        if (scroll) scroll(e)
      }}
      tabIndex="0"
      display="inline-block"
      text={text}
    >
      <RawHTML>{text}</RawHTML>
      {option.image ? <MediaBox media={option.image} /> : null}
    </Option>
  )
}
export default injectIntl(OptionButton)



// WEBPACK FOOTER //
// ./assets/common/components/OptionButton.js